import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const AI_SWITCH_PERSIST_KEY = 'ai-switch-store';
const AI_SWITCH_LEGACY_KEY = 'isAISwitchOn';

type AISwitchStore = {
  isAISwitchOn: boolean;
  setIsAISwitchOn: (isAISwitchOn: boolean) => void;
};

const getDefaultAISwitchState = () => {
  if (globalThis.window === undefined) return false;

  const legacyState = sessionStorage.getItem(AI_SWITCH_LEGACY_KEY);
  if (legacyState != null) {
    return legacyState === 'true';
  }

  return false;
};

export const useAISwitchStore = create<AISwitchStore>()(
  persist(
    (set) => ({
      isAISwitchOn: getDefaultAISwitchState(),
      setIsAISwitchOn: (isAISwitchOn) => set({ isAISwitchOn }),
    }),
    {
      name: AI_SWITCH_PERSIST_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ isAISwitchOn: state.isAISwitchOn }),
    },
  ),
);
